import { render } from "./KaratayKatmanlar.vue?vue&type=template&id=765d71aa&scoped=true"
import script from "./KaratayKatmanlar.vue?vue&type=script&lang=js"
export * from "./KaratayKatmanlar.vue?vue&type=script&lang=js"

import "./KaratayKatmanlar.vue?vue&type=style&index=0&id=765d71aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765d71aa"]])

export default __exports__